import {
  Flame,
  Gamepad2,
  Ghost,
  Globe,
  Instagram,
  Linkedin,
  MessageCircle,
  MessageSquare,
  Music2,
  Network,
  Pin,
  Quote,
  Send,
  Share2,
  Signal,
  Slack,
  Twitter,
  Youtube,
} from "lucide-react";
import type { ComponentType } from "react";

import { cn } from "@/lib/utils";

interface PlatformIconProps {
  platform: string;
  className?: string;
}

// Map platform keys to SVG icon paths in the public folder
// Only include platforms that have actual SVG files
const PLATFORM_SVG_MAP: Record<string, string> = {
  facebook: "/social-media-icons/facebook.svg",
  twitter: "/social-media-icons/x.svg",
  pinterest: "/social-media-icons/pinterest.svg",
  whatsapp: "/social-media-icons/whatsapp.svg",
  instagram: "/social-media-icons/instagram.svg",
  reddit: "/social-media-icons/reddit.svg",
  discord: "/social-media-icons/discord.svg",
  telegram: "/social-media-icons/telegram.svg",
  snapchat: "/social-media-icons/snapchat.svg",
  tiktok: "/social-media-icons/tiktok.svg",
  wechat: "/social-media-icons/wechat.svg",
  tumblr: "/social-media-icons/tumblr.svg",
  mastodon: "/social-media-icons/mastodon.svg",
  signal: "/social-media-icons/signal.svg",
  youtube: "/social-media-icons/youtube.svg",
  bluesky: "/social-media-icons/bluesky.svg",
  github: "/social-media-icons/github.svg",
};

const FALLBACK_ICON_MAP: Record<string, ComponentType<{ className?: string }>> = {
  facebook: Share2,
  twitter: Twitter,
  linkedin: Linkedin,
  pinterest: Pin,
  whatsapp: MessageCircle,
  slack: Slack,
  instagram: Instagram,
  reddit: Flame,
  discord: Gamepad2,
  telegram: Send,
  snapchat: Ghost,
  tiktok: Music2,
  wechat: MessageSquare,
  tumblr: Quote,
  mastodon: Network,
  signal: Signal,
  youtube: Youtube,
  direct: Share2,
  other: Globe,
};

export function PlatformIcon({ platform, className }: PlatformIconProps) {
  const svgPath = PLATFORM_SVG_MAP[platform];

  if (svgPath) {
    return (
      <img
        src={svgPath}
        alt={`${platform} icon`}
        className={cn("h-4 w-4", className, platform === "twitter" && "dark:invert")}
      />
    );
  }

  const FallbackIcon = FALLBACK_ICON_MAP[platform] || Globe;
  return <FallbackIcon className={cn("h-4 w-4", className)} />;
}
